(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.OnlineWebLeads",
                    {
                        url: "/OnlineWebLeads/{year}&{monthId}",
                        component: "onlineWebLeads",
                        PageTitle: "Lead Source | Marketing Tracker"
                    });
        }
    ]);

    app.component("onlineWebLeads",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/OnlineWebLeads/online-web-leads-template.html",
            controller: onlineWebLeadsController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    onlineWebLeadsController.$inject = ["marketingTrackerActOnApi", "$rootScope", "$state", "$scope"];
    function onlineWebLeadsController(marketingTrackerActOnApi, $rootScope, $state, $scope) {

        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    loadingChart: false,
                    loadingData: false,
                    showContacts: false
                },
                charts: [
                    { Title: 'Count by Source', Icon: 'fig-share', HeaderColor: 'purple', Color: ['209,196,240', '160,123,234'] },
                    { Title: 'Count by Assets', Icon: 'fig-cash-multiple', HeaderColor: 'green-dark', Color: ['135,207,162', '148,225,175'] },
                    { Title: 'Count by Forms', Icon: 'fig-document-multiple', HeaderColor: 'orange', Color: ['234,140,27', '251,199,133'] }
                ],
                contactList: [],
                currentDate: moment(),
                formData: null,
                months: [
                    { Name: 'January', Id: 1 },
                    { Name: 'February', Id: 2 },
                    { Name: 'March', Id: 3 },
                    { Name: 'April', Id: 4 },
                    { Name: 'May', Id: 5 },
                    { Name: 'June', Id: 6 },
                    { Name: 'July', Id: 7 },
                    { Name: 'August', Id: 8 },
                    { Name: 'September', Id: 9 },
                    { Name: 'October', Id: 10 },
                    { Name: 'November', Id: 11 },
                    { Name: 'December', Id: 12 },
                    { Name: 'All', Id: -1 }
                ],
                resetDate: resetDate,
                selected: [],
                toggleSort: toggleSort,
                years: []
            });

        //var webLeadsChart = false;
        //$scope.$on("chart-create", function (event, instance) {
        //    if (instance.canvas.id === "webLeadChart") {
        //        webLeadsChart = instance;
        //        $scope.chart = instance.chart;
        //    }
        //});

        function resetDate(dateObj) {
            _getFormData(dateObj);
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _buildChart(dataGroup, index) {
            var dataArray = dataGroup.Items;
            var dataLabels = dataArray.map(function (a) { return a.Name; });
            var dataShortLabels = dataArray.map(function (a) { return _textTruncate(a.Name, 20, '...'); });
            var dataInfo = dataArray.map(function (a) { return a.Count; });
            var dataIndexes = dataArray.map(function (a, i) { return i; });
            var rgbColors = $ctrl.charts[index].Color;
            var dataColors = dataArray.map(function () {
                return {
                    backgroundColor: "rgba(" + rgbColors[0] + ", 0.2)",
                    pointBackgroundColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointHoverBackgroundColor: "rgba(" + rgbColors[0] + ", 0.8)",
                    borderColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(" + rgbColors[0] + ", 1)"
                };
            });
            $ctrl.charts[index].data = {
                labels: index === 2 ? dataIndexes : dataShortLabels,
                series: ['Opens', 'CTR'],
                colors: Object.values(dataColors),
                data: dataInfo,
                //onClick: function (points, evt) {
                //    console.log(points, evt);
                //},
                //datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
                options: {
                    //layout: {
                    //    padding: {
                    //        left: 10,
                    //        right: 10,
                    //        top: 0,
                    //        bottom: 0
                    //    }
                    //},
                    legend: { display: false },
                    maintainAspectRatio: false,
                    responsive: true,
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: { beginAtZero: true }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: false,
                                position: 'right',
                                ticks: { beginAtZero: true }
                            }
                        ]
                    },
                    tooltips: {
                        callbacks: {
                            title: function (obj) {
                                return dataLabels[obj[0].index];
                            }
                        }
                    }
                }
            };
        }

        //$scope.goToLeads = function (elements, e) {
        //    var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

        //    var intersect = elements.find(function (element) {
        //        return element.inRange(pos.x, pos.y);
        //    });
        //    if (intersect) {
        //        $ctrl.itemIndex = intersect._index;
        //        _getContacts($ctrl.selectedSource.Id, $ctrl.itemIndex);
        //        //$state.go("Home.Tools.MarketingTrackerNew.DigitalMarketing.OnlineWebLeads", { formId: $state.params.formId, grouping: $ctrl.groupingIndex, item: intersect._index }, { notify: false });                
        //    }
        //};

        function _textTruncate(fullString, length, ending) {
            if (length === null) {
                length = 50;
            }
            if (ending === null) {
                ending = '...';
            }
            var strLength = !!fullString ? fullString.length : 0;
            if (strLength > length) {
                return fullString.substring(0, length - ending.length) + ending;
            } else {
                return fullString;
            }
        }

        function _getContacts(groupingIndex, itemIndex) {
            var grouping = groupingIndex !== null ? groupingIndex : $ctrl.groupingIndex,
                item = itemIndex !== null ? itemIndex : $ctrl.itemIndex,
                formgroup = $ctrl.formData.Groupings[grouping],
                formItems = formgroup.Items[item];
            $ctrl.groupingIndex = grouping;
            $ctrl.itemIndex = item;
            $ctrl.contactList = formItems.Contacts;
            $rootScope.$apply();
        }

        function _refreshContacts(formData) {
            $ctrl.ui.loadingContacts = true;
            $ctrl.submissionList = [];
            $ctrl.contactList = [];

            //gathering contacts only from the first grouping, as they all represent the same number of sumbissions
            //_.forEach(formData.Groupings, function (grouping) {
            _.forEach(formData.Groupings[0].Items, function (item) {
                $ctrl.submissionList = $ctrl.submissionList.concat(item.Contacts);
            });
            //});
            $ctrl.contactList = _.uniqBy($ctrl.submissionList, 'ContactId');
            //console.log("unique", $ctrl.contactList);
            //console.log("non-unique", $ctrl.submissionList);

            $ctrl.ui.loadingContacts = false;
        }

        function _getFormData(timeFrame) {
            $ctrl.ui.loadingChartData = true;

            var endDate = !!timeFrame
                ? timeFrame.month.Id === -1
                    ? moment.utc().set({ 'year': timeFrame.year }).endOf('year').format()
                    : moment.utc().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).endOf('month').format()
                : moment.utc().endOf('month').format(),
                startDate = !!timeFrame
                    ? timeFrame.month.Id === -1
                        ? moment.utc().set({ 'year': timeFrame.year }).startOf('year').format()
                        : moment.utc().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).startOf('month').format()
                    : moment.utc().startOf('month').format();

            marketingTrackerActOnApi.getFormLogListByDateRange(startDate, endDate)
                .then(function (response) {
                    $ctrl.formData = response;

                    $ctrl.formData.Groupings.forEach(function (group) {
                        group.Id = group.Description !== 'Count by Source'
                            ? group.Description !== 'Count by Net Value'
                                ? group.Description !== 'Count by Form'
                                    ? 3
                                    : 2
                                : 1
                            : 0;
                        //if (!queryProvided && group.Description.includes("Source")) {
                        //$ctrl.groupingIndex = i;
                        //}
                        _buildChart(group, group.Id);
                    });

                    //$ctrl.selectedSource = groupings[$ctrl.groupingIndex];
                    //resetChart($ctrl.selectedSource);
                    _refreshContacts($ctrl.formData);
                })
                .finally(function () {
                    $ctrl.ui.loadingChartData = false;
                    $state.go("Home.Tools.MarketingTrackerNew.DigitalMarketing.OnlineWebLeads", { year: $ctrl.selected.year, monthId: $ctrl.selected.month.Id }, { notify: false });
                });
        }
        function _resetFilters(propertyName) {
            $ctrl.propertyName = propertyName || 'Date';
        }

        function _parseQueryParameters() {
            if ($state.params.grouping) {
                var gParsed = parseInt($state.params.grouping);
                if (gParsed) {
                    $state.params.grouping = gParsed;
                } else {
                    $state.params.grouping = 0;
                }
                $ctrl.groupingIndex = $state.params.grouping;
            } else $ctrl.groupingIndex = 0;

            if ($state.params.item) {
                var iParsed = parseInt($state.params.item);
                if (iParsed) {
                    $state.params.grouping = iParsed;
                } else {
                    $state.params.grouping = 0;
                }
                $ctrl.itemIndex = $state.params.item;
            } else $ctrl.itemIndex = 0;
        }

        $ctrl.$onInit = function () {
            for (var i = 2015; i <= $ctrl.currentDate.year(); i++) {
                $ctrl.years.push(i);
            }
            $ctrl.selected.month = !!$state.params.monthId
                ? _.find($ctrl.months, function (month) { return month.Id === Number($state.params.monthId); })
                : _.find($ctrl.months, function (month) { return month.Id === -1; });
            $ctrl.selected.year = !!$state.params.year ? Number($state.params.year) : _.find($ctrl.years, function (year) { return year === $ctrl.currentDate.year(); });
            $ctrl.ui.showContacts = false;
            _parseQueryParameters();
            _resetFilters();
            _getFormData($ctrl.selected);
        };
    }
})(window.app, window.angular); //jshint ignore:line